import { render, staticRenderFns } from "./UserPlan.v2.vue?vue&type=template&id=0754fa30&scoped=true&"
import script from "./UserPlan.v2.vue?vue&type=script&lang=js&"
export * from "./UserPlan.v2.vue?vue&type=script&lang=js&"
import style0 from "./UserPlan.v2.vue?vue&type=style&index=0&id=0754fa30&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0754fa30",
  null
  
)

export default component.exports